
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_13jl4_153",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_13jl4_154",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_13jl4_155",
  "visible-content-group": "awsui_visible-content-group_tc96w_13jl4_155",
  "visible-content-title": "awsui_visible-content-title_tc96w_13jl4_160",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_13jl4_170",
  "visible-content-option": "awsui_visible-content-option_tc96w_13jl4_176",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_13jl4_189",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_13jl4_212",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_13jl4_216",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_13jl4_256",
  "content-display": "awsui_content-display_tc96w_13jl4_212",
  "content-display-text-filter": "awsui_content-display-text-filter_tc96w_13jl4_264",
  "content-display-no-match": "awsui_content-display-no-match_tc96w_13jl4_265",
  "content-display-title": "awsui_content-display-title_tc96w_13jl4_269",
  "content-display-description": "awsui_content-display-description_tc96w_13jl4_278",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_13jl4_286",
  "root": "awsui_root_tc96w_13jl4_293",
  "modal-root": "awsui_modal-root_tc96w_13jl4_294",
  "trigger-button": "awsui_trigger-button_tc96w_13jl4_295",
  "cancel-button": "awsui_cancel-button_tc96w_13jl4_296",
  "confirm-button": "awsui_confirm-button_tc96w_13jl4_297",
  "custom": "awsui_custom_tc96w_13jl4_298",
  "content-before": "awsui_content-before_tc96w_13jl4_299",
  "second-column-small": "awsui_second-column-small_tc96w_13jl4_303",
  "wrap-lines": "awsui_wrap-lines_tc96w_13jl4_307",
  "striped-rows": "awsui_striped-rows_tc96w_13jl4_308",
  "content-density": "awsui_content-density_tc96w_13jl4_309",
  "page-size": "awsui_page-size_tc96w_13jl4_310",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_13jl4_311",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_13jl4_312",
  "sticky-columns": "awsui_sticky-columns_tc96w_13jl4_313",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_13jl4_314",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_13jl4_315",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_13jl4_316",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_13jl4_317"
};
  